import { Box, SxProps, Typography } from "@mui/material";
import React from "react";
import ashiraiImage from "url:src/assets/images/ashirai.png";

type Props = {
  id?: string;
  title?: string;
  children: React.ReactNode;
  colored?: boolean;
  sx?: SxProps;
};

export default function Section({ id, title, children, colored, sx }: Props) {
  return (
    <Box
      id={id}
      sx={{
        width: "100%",
        py: "60px",
        px: 2.5,
        bgcolor: colored ? "primary.light" : "transparent",
        ...sx,
      }}
    >
      {title && (
        <Box sx={{ display: "flex", justifyContent: "center", mb: 4 }}>
          <Typography
            fontSize="20px"
            fontWeight="bold"
            letterSpacing="0.13em"
            sx={{
              position: "relative",
              display: "inline-block",
              "&::after": {
                content: '""',
                position: "absolute",
                top: "-14px",
                right: "-22px",
                width: "30px",
                height: "20px",
                scale: "0.8",
                backgroundImage: `url(${ashiraiImage})`,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
              },
            }}
          >
            {title}
          </Typography>
        </Box>
      )}
      {children}
    </Box>
  );
}
